(() => {
  const HM = (window.HM = window.HM || {});

  // Teilen-Link-Brücke (28.09., Gegenstück zu layout/password.liquid): Hat die
  // Passwortseite ein Link-Ziel gemerkt (#z=… am geteilten Warenkorb-Link),
  // von hier — Shopify leitet nach der Passworteingabe immer auf die
  // Startseite — dorthin weiterspringen. Nur frische Ziele (15 Min), nur
  // eigene Links (gleiche Origin oder is.gd-Kurzlink), nur von der Startseite.
  try {
    if (location.pathname === '/' && sessionStorage.getItem('hm_ziel')) {
      const z = JSON.parse(sessionStorage.getItem('hm_ziel'));
      sessionStorage.removeItem('hm_ziel');
      const ziel = new URL(z.u, location.origin);
      const erlaubt = ziel.origin === location.origin || (ziel.origin === 'https://is.gd' && ziel.protocol === 'https:');
      if (erlaubt && Date.now() - z.t < 15 * 60 * 1000) {
        location.replace(ziel.origin === location.origin ? ziel.pathname + ziel.search : ziel.href);
      }
    }
  } catch (e) { /* Storage geblockt oder kaputtes Ziel - normal weiterladen */ }

  class HmDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) this.dialog.close();
      });
    }
    open() {
      if (this.dialog && !this.dialog.open) this.dialog.showModal();
    }
    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
  }
  if (!customElements.get('hm-drawer')) customElements.define('hm-drawer', HmDrawer);

  HM.drawer = {
    open(id) {
      const el = document.getElementById(id);
      if (el && typeof el.open === 'function') el.open();
    }
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-drawer-open]');
    if (!trigger) return;
    e.preventDefault();
    HM.drawer.open(trigger.getAttribute('data-drawer-open'));
  });

  // Mobile-Menü nach Linkklick schließen
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.site-header__mobile-nav a, .club-header__mobile-nav a');
    if (!link) return;
    const details = link.closest('details');
    if (details) details.removeAttribute('open');
  });

  class HmSlider extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-slider-track]');
      if (!track) return;
      const step = () => track.clientWidth * 0.8;
      this.querySelector('[data-slider-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.querySelector('[data-slider-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      const sync = () => {
        const prev = this.querySelector('[data-slider-prev]');
        const next = this.querySelector('[data-slider-next]');
        if (prev) prev.toggleAttribute('hidden', track.scrollLeft <= 4);
        if (next) next.toggleAttribute('hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }
  if (!customElements.get('hm-slider')) customElements.define('hm-slider', HmSlider);

  class HmTabs extends HTMLElement {
    connectedCallback() {
      this.tab = this.querySelector('[data-tab]')?.dataset.tab;
      this.chip = this.querySelector('[data-chip]')?.dataset.chip;
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-tab]');
        const c = e.target.closest('[data-chip]');
        if (t) this.tab = t.dataset.tab;
        else if (c) this.chip = c.dataset.chip;
        else return;
        this.update();
      });
      this.update();
    }
    update() {
      this.querySelectorAll('[data-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.tab === this.tab)));
      this.querySelectorAll('[data-chip]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.chip === this.chip)));
      this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== `${this.tab}:${this.chip}`; });
    }
  }
  if (!customElements.get('hm-tabs')) customElements.define('hm-tabs', HmTabs);

  class HmHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-hotspot]');
        if (!dot) return;
        const scope = this.closest('section') || document;
        const id = dot.getAttribute('data-hotspot');
        this.querySelectorAll('[data-hotspot]').forEach((d) => d.setAttribute('aria-expanded', String(d === dot)));
        scope.querySelectorAll('[data-hotspot-item]').forEach((item) => {
          const active = item.getAttribute('data-hotspot-item') === id;
          item.classList.toggle('is-active', active);
          if (active && item.scrollIntoView) item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      });
    }
  }
  if (!customElements.get('hm-hotspots')) customElements.define('hm-hotspots', HmHotspots);

  // Consent-Banner-Guard (19.09.): Der Shopify-Cookie-Banner kann in einem
  // Zwischenzustand haengen, in dem er UNSICHTBAR ist, aber weiter Klicks frisst
  // (Vorfall 18.09.: "Angebot anfordern" tat gar nix). Der Guard setzt den Banner
  // nur dann auf pointer-events:none, wenn er nachweislich unsichtbar ist —
  // ein sichtbarer Banner (Akzeptieren/Ablehnen) wird NIE angefasst und beim
  // Wieder-Sichtbarwerden sofort zurueckgesetzt.
  const bannerUnsichtbar = (el) => {
    const r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false; // nimmt keinen Platz ein, frisst nichts
    const cs = getComputedStyle(el);
    if (Number(cs.opacity) < 0.05 || cs.visibility === 'hidden') return true;
    const root = el.shadowRoot;
    if (!root) return false;
    return !Array.from(root.querySelectorAll('*')).some((k) => {
      const kr = k.getBoundingClientRect();
      if (!kr.width || !kr.height) return false;
      const kcs = getComputedStyle(k);
      return kcs.visibility !== 'hidden' && Number(kcs.opacity) >= 0.05;
    });
  };
  let entschieden = false;   // nach Akzeptieren/Ablehnen/× auf dieser Seite keine Sperrfläche mehr
  const consentGuard = () => {
    document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs').forEach((el) => {
      const aus = bannerUnsichtbar(el);
      if (aus && el.style.pointerEvents !== 'none') el.style.pointerEvents = 'none';
      else if (!aus && el.style.pointerEvents === 'none') el.style.pointerEvents = '';
    });
    // „×“ oben rechts (02.11., Kevin): wirkt exakt wie „Ablehnen“, Schließen darf nie als Zustimmung zählen
    const banner = document.getElementById('shopify-pc__banner');
    if (banner && !banner.querySelector('.pc-schliessen')) {
      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'pc-schliessen';
      x.setAttribute('aria-label', 'Schließen und ablehnen');
      x.textContent = '×';
      x.addEventListener('click', () => {
        const ablehnen = document.getElementById('shopify-pc__banner__btn-decline');
        if (ablehnen) ablehnen.click();
      });
      banner.appendChild(x);
      // Sichtbar erklären, was × tut (CNIL Rn. 33), und Impressum aus dem Fenster erreichbar halten (DSK OH Rn. 121)
      const zusatz = document.createElement('p');
      zusatz.className = 'pc-zusatz';
      zusatz.innerHTML = 'Schließen mit × = ablehnen. · <a href="/pages/impressum">Impressum</a>';
      banner.appendChild(zusatz);
    }
    // Handy: echte Sperrfläche hinter dem mittigen Fenster, solange es sichtbar ist (Tipps darauf lösen nichts aus)
    let sperre = document.querySelector('.pc-sperre');
    const sperren = !entschieden && !!banner && !bannerUnsichtbar(banner) && window.matchMedia('(max-width: 749px)').matches;
    if (sperren && !sperre) {
      sperre = document.createElement('div');
      sperre.className = 'pc-sperre';
      sperre.setAttribute('aria-hidden', 'true');
      document.body.appendChild(sperre);
    }
    if (sperre) sperre.hidden = !sperren;
  };
  consentGuard();
  setInterval(consentGuard, 1000);
  // Nach einer Entscheidung im Banner die Sperrfläche sofort entfernen, nicht erst beim nächsten Intervall
  document.addEventListener('click', (e) => {
    if (!e.target.closest || !e.target.closest('#shopify-pc__banner')) return;
    if (e.target.closest('#shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline, .pc-schliessen')) {
      entschieden = true;
      const s = document.querySelector('.pc-sperre');
      if (s) s.hidden = true;
    }
    [150, 400, 800, 1500].forEach((ms) => setTimeout(consentGuard, ms));
  }, true);
})();
